import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectTextLeft32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMediaObjectTextLeft32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M21 7h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m-4 2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4zM3 8a1 1 0 0 1 1-1h9.5a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h9.5a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m6-5a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2zm-1 9a1 1 0 0 1 1-1h4.5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectTextLeft32);
